import log from "loglevel";
import { validObject } from "./validation";

const AUTH_KEY = "ats-auth";
const USER_KEY = "ats-user";
export const loadAuth = () => {
    try {
        const serializedState = localStorage.getItem(AUTH_KEY);
        if (!validObject(serializedState)) {
            return null;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        log.error("loading auth in locals tore error ", err);
        return {};
    }
};

export const removeAuth = () => {
    try {
        localStorage.removeItem(AUTH_KEY);
    } catch (err) {
        log.error(`unable to remove ${AUTH_KEY} `, err);
    }
};
export const saveAuth = (oauth) => {
    try {
        const serializedState = JSON.stringify(oauth);
        localStorage.setItem(AUTH_KEY, serializedState);
    } catch (err) {
        log.error(err);
    }
};

export const saveUser = (user) => {
    const serializedUser = JSON.stringify(user);
    localStorage.setItem(USER_KEY, serializedUser);
};
export const loadUser = () => {
    const user = JSON.parse(localStorage.getItem(USER_KEY));
    return user;
};
